import { render, staticRenderFns } from "./EditItem.vue?vue&type=template&id=8038d9ba&scoped=true&"
import script from "./EditItem.vue?vue&type=script&lang=ts&"
export * from "./EditItem.vue?vue&type=script&lang=ts&"
import style0 from "./EditItem.vue?vue&type=style&index=0&id=8038d9ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8038d9ba",
  null
  
)

export default component.exports